import Auth from './auth/reducer';
import App from './app/reducer';
import Speciality from './speciality/reducer';
import ThemeSwitcher from './themeSwitcher/reducer';
import LanguageSwitcher from './languageSwitcher/reducer';
export default {
  Auth,
  App,
  Speciality,
  ThemeSwitcher,
  LanguageSwitcher,
};
